import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Icon, Table, Popup, Button } from 'semantic-ui-react';

import hasRestClient from '../../../hocs/has-rest-client';
import FavouriteStar from '../../favourite-star';
import TargetLink from '../../target-link';
import AssetTypeIcon from '../../asset-type-icon';

const DeleteButton = props => <Button
  size="mini"
  onClick={props.handler}
  compact
  circular
  icon="delete"
/>;

const deleteAsset = (asset, restClient) => {
  const deleteUrl = `trackedAssets/${asset.id}`;
  console.log(deleteUrl);
  return restClient.delete(deleteUrl).then(() => window.location.reload(true));
};
const SnapChatAsset = ({
  asset,
  favouriteStateHandler,
  uploadSupportingDataComponent,
  supportingDataComponent,
  restClient,
}) => (
  <Table.Row>
    <Table.Cell>
      <Popup
        content={<span>Snapchat { _.capitalize(_.get(asset, 'assetType', 'post')) }</span>}
        trigger={<AssetTypeIcon asset={asset} />}
      />
    </Table.Cell>
    <Table.Cell textAlign="left">
      <TargetLink renderIf href={_.get(asset, 'assetURL')}>
        { _.get(asset, 'extraData.text', '-') }
      </TargetLink>
    </Table.Cell>
    <Table.Cell><Icon name="circle thin" color="grey" /></Table.Cell>
    <Table.Cell><Icon name="minus" color="grey" /></Table.Cell>
    <Table.Cell>
      <FavouriteStar asset={asset} onClick={favouriteStateHandler} />
    </Table.Cell>
    <Table.Cell>
      {uploadSupportingDataComponent}
    </Table.Cell>
    <Table.Cell>{supportingDataComponent}</Table.Cell>
    <Table.Cell>
      <DeleteButton
        handler={() => deleteAsset(asset, restClient)}
      />
    </Table.Cell>
  </Table.Row>
);

SnapChatAsset.propTypes = {
  asset: PropTypes.object.isRequired,
  uploadSupportingDataComponent: PropTypes.object.isRequired,
  supportingDataComponent: PropTypes.object.isRequired,
  favouriteStateHandler: PropTypes.func.isRequired,
  restClient: PropTypes.object.isRequired,
};

export default hasRestClient(SnapChatAsset);



/** WEBPACK FOOTER **
 ** ./src/components/asset-table/assets-type/snapchat.js
 **/